export default __webpack_public_path__ + "src/assets/credits-nansen.a2f1006f4310d24936cc50c75475b0a5.svg";